import { FC } from "react";
import {
  SearchOutlined,
  CloseCircleOutlined,
  FileAddOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import { Button, Col, Input, Row, Select, Tooltip } from "antd";
import styles from "./index.module.scss";
import { SearchAndFilterProps } from "./types";
import { useSelector } from "react-redux";

const INCOMING_ALLOWED_ROLES = ["Admin 3nStar", "3nStar Employee 1", "3nStar Employee 2"];

const SearchAndFilter: FC<SearchAndFilterProps> = (props) => {
  const {
    performSearchHandler,
    handleExtendWarranty,
    handleUploadInvoice,
    searchValue,
    searchFieldsSelectHandler,
    resetButtonHandler,
    searchFields,
    menuName,
    options,
    showAvailabilityFilter,
    availabilityFilterValue,
    availabilityFilterChangeHandler,
    handleUploadIncoming,
    handleReviewSiteQty,
  } = props;

  const searchWarrantyRuleStyle =
    menuName === "Warranty-Rules" ? { paddingLeft: 0 } : {};

  const profileData = useSelector(
    (state: { userProfile?: { data?: { companyRoles?: Array<{ role?: { roleName?: string } }> } } }) =>
      state?.userProfile?.data
  );

  return (
    <div className={styles["search-filter"]}>
      <div
        className={styles["search-filter__wrapper"]}
        style={searchWarrantyRuleStyle}
      >
        <Row gutter={[8, 8]} align="middle" justify="start">
          {/* Input Field */}
          <Col xs={24} sm={10} md={8} lg={7} xl={6}>
            <Input
              className={styles["search-filter__search"]}
              placeholder="Search..."
              suffix={<SearchOutlined />}
              onChange={performSearchHandler}
              value={searchValue}
              size="large"
              disabled={searchFields.length === 0}
            />
          </Col>

          {/* Select Field */}
          <Col xs={24} sm={10} md={8} lg={7} xl={6}>
            <Select
              className={styles["search-filter__select"]}
              mode="multiple"
              maxTagCount="responsive"
              maxTagPlaceholder={(omittedValues) => {
                return (
                  <Tooltip
                    mouseLeaveDelay={0.1}
                    title={omittedValues.map(({ label }) => label).join(", ")}
                    destroyTooltipOnHide={true}
                  >
                    <span>+{omittedValues?.length} more..</span>
                  </Tooltip>
                );
              }}
              allowClear
              style={{ width: "100%" }}
              placeholder="Search on fields"
              onChange={searchFieldsSelectHandler}
              options={options}
              value={searchFields}
            />
          </Col>

          {showAvailabilityFilter && (
            <Col xs={24} sm={10} md={8} lg={7} xl={6}>
              <Select
                className={`${styles["search-filter__select"]}`}
                style={{ width: "100%" }}
                placeholder="Availability"
                size="large"
                allowClear
                showSearch
                optionFilterProp="label"
                filterOption={(input, option) =>
                  String(option?.label || "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                value={availabilityFilterValue}
                onChange={(value) =>
                  availabilityFilterChangeHandler &&
                  availabilityFilterChangeHandler(value)
                }
                options={[
                  { label: "All", value: "ALL" },
                  { label: "Available", value: "AVAILABLE" },
                  { label: "Limited Availability", value: "LIMITED" },
                  { label: "Check Availability", value: "CHECK" },
                ]}
              />
            </Col>
          )}

          {/* Reset Button */}
          <Col flex="none">
            <Button
              type="primary"
              className={styles["search-filter__reset"]}
              icon={<CloseCircleOutlined />}
              onClick={resetButtonHandler}
            >
              Reset
            </Button>
          </Col>

          {/* Conditionally Render Extend Warranty Button */}
          {((menuName === "Sales" || menuName === "Warranty-Rules") &&
            profileData?.companyRoles[0]?.role?.roleName === "Admin 3nStar") ||
          profileData?.companyRoles[0]?.role?.roleName ===
            "3nStar Employee 1" ? (
            <>
              {menuName === "Sales" && handleUploadInvoice && (
                <Col flex="none">
                  <Button
                    type="primary"
                    className={styles["search-filter__reset"]}
                    onClick={() => handleUploadInvoice(true)}
                  >
                    <UploadOutlined />
                    Import Serials(Excel)
                  </Button>
                </Col>
              )}
              <Col flex="none">
                <Button
                  type="primary"
                  className={styles["search-filter__reset"]}
                  onClick={
                    handleExtendWarranty && (() => handleExtendWarranty(true))
                  }
                >
                  <FileAddOutlined />
                  {menuName === "Warranty-Rules"
                    ? "Import Rules"
                    : "Import Extended Warranty"}
                </Button>
              </Col>
            </>
          ) : (
            ""
          )}

          {menuName === "ItemInventory" &&
            INCOMING_ALLOWED_ROLES.includes(
              profileData?.companyRoles?.[0]?.role?.roleName || ""
            ) && (
              <>
                {handleReviewSiteQty && (
                  <Col flex="none">
                    <Button
                      type="primary"
                      className={styles["search-filter__reset"]}
                      onClick={() => handleReviewSiteQty()}
                    >
                      <UploadOutlined />
                      Update QTY
                    </Button>
                  </Col>
                )}
                {handleUploadIncoming && (
                  <Col flex="none">
                    <Button
                      type="primary"
                      className={styles["search-filter__reset"]}
                      onClick={() => handleUploadIncoming()}
                    >
                      <UploadOutlined />
                      Upload Incoming Inventory
                    </Button>
                  </Col>
                )}
              </>
            )}
        </Row>
      </div>
    </div>
  );
};

export default SearchAndFilter;
